import React from 'react';
import type { FigureLegendEntry } from '../../types/payloads/figureLegend.types';
import { VexRhythmGlyph } from './VexRhythmGlyph';

export function FigureLegendPanel({
  entries,
  printMode = false,
  title = 'Figuras en esta obra',
  className = '',
}: {
  entries: FigureLegendEntry[];
  printMode?: boolean;
  title?: string;
  className?: string;
}) {
  if (!entries.length) return null;

  const rootClass = [
    'figure-legend-panel',
    printMode ? 'figure-legend-panel--print' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <p className="figure-legend-panel__title">{title}</p>
      <div className="figure-legend-panel__grid">
        {entries.map((entry) => (
          <div key={entry.token} className="figure-legend-panel__item">
            <div className="figure-legend-panel__glyph">
              <VexRhythmGlyph
                token={entry.token}
                size={printMode ? 44 : 48}
                printMode={printMode}
                dotted={entry.dotted}
              />
            </div>
            <div className="figure-legend-panel__meta">
              <p className="figure-legend-panel__label">{entry.label}</p>
              <p className="figure-legend-panel__duration">{entry.duration}</p>
              {entry.description && (
                <p className="figure-legend-panel__desc">{entry.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
